import script from "./labarticle.vue?vue&type=script&setup=true&lang=js"
export * from "./labarticle.vue?vue&type=script&setup=true&lang=js"

import "./labarticle.vue?vue&type=style&index=0&id=c55cef76&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c55cef76"]])

export default __exports__